import {createSelector} from 'reselect';
import {combineReducers, AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';

import megatron from '@stencil/megatron';
import { getCookie } from '../../../verticals/bus-dweb/src/shared/containers/Review/Utils';
import { encrypt, getSessionID, setSessionStorage } from '../../../verticals/bus-dweb/src/shared/containers/Common/Utils';
import dateformat from 'dateformat';
// ! move prepareCommonUserWidget to API
// ! should split out and have multiple imports for usage
// ! e.g. - @stencil/user-reducer/selectors or /actions likewise

export interface IUserStoreState {
  userInfo: IUserInfo;
  gocashInfo: IGocashInfo;
  isLoading: boolean;
  showLoginPopup: boolean;
  isLoggedIn: boolean;
  loyaltyInfo:IUserLoyaltyInfo
}

export interface IUserInfo {
  first_name?: string;
  last_name?: string;
  email?: string;
  profileId: number;
  profile_type?: string;
  image_url?: string;
  hashedemail?: string;
  auth_token?: string;
  gender?: string;
  username?: string;
  uuid?: string;
  userid?:string;
}

export interface IGocashInfo {
  // success: boolean;
  // data: {
    credits_id?: string;
    np_amt?: number;
    p_amt?: number;
    is_locked?: number;
    b_amt?: number;
    t_amt?: number;
  // };
}

export interface IUserLoyaltyInfo {
  currentTier?:{},
  uuid?: string,
  status?:string,
  program?:string, 
  firstName?:string,
  lastName?:string,
}

export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_USER_GO_CASH_INFO = 'UPDATE_USER_GO_CASH_INFO';
export const TOGGLE_LOADING_USER_DETAILS = 'TOGGLE_LOADING_USER_DETAILS';
export const TOGGLE_LOGIN_POPUP = 'TOGGLE_LOGIN_POPUP';
export const UPDATE_USER_LOYALTY_STATUS = 'UPDATE_USER_LOYALTY_STATUS';

export interface IUpdateUserDetails {
  type: typeof UPDATE_USER_DETAILS;
  actionData: {
    userInfo: IUserStoreState['userInfo'];
    isLoggedIn: IUserStoreState['isLoggedIn'];
  };
}
export interface IUpdateUserGoCashInfo {
  type: typeof UPDATE_USER_GO_CASH_INFO;
  actionData: {
    gocashInfo: IUserStoreState['gocashInfo'];
  };
}
export interface IUpdateLoyaltyStatusInfo {
  type: typeof UPDATE_USER_LOYALTY_STATUS;
  actionData: {
    loyaltyInfo: IUserStoreState['loyaltyInfo'];
  };
}

export interface IToggleLoadingUserDetails {
  type: typeof TOGGLE_LOADING_USER_DETAILS;
  actionData: IUserStoreState['isLoading'];
}

export interface IToggleLoginPopup {
  type: typeof TOGGLE_LOGIN_POPUP;
  actionData: IUserStoreState['showLoginPopup'];
}

export type IUserActionTypes = IUpdateUserDetails | IUpdateUserGoCashInfo | IToggleLoadingUserDetails | IToggleLoginPopup | IUpdateLoyaltyStatusInfo;

export function updateUserDetailsAction(
  actionData: IUpdateUserDetails['actionData'],
): IUpdateUserDetails {
  return {
    type: UPDATE_USER_DETAILS,
    actionData,
  };
}
export function updateUserGoCashAction(
  actionData: IUpdateUserGoCashInfo['actionData'],
): IUpdateUserGoCashInfo {
  return {
    type: UPDATE_USER_GO_CASH_INFO,
    actionData,
  };
}

export function updateUserLoyaltyStatusAction(
  actionData: IUpdateLoyaltyStatusInfo['actionData'],
): IUpdateLoyaltyStatusInfo {
  return {
    type: UPDATE_USER_LOYALTY_STATUS,
    actionData,
  };
}

export function toggleLoadingUserDetailsAction(
  actionData: IToggleLoadingUserDetails['actionData'],
): IToggleLoadingUserDetails {
  return {
    type: TOGGLE_LOADING_USER_DETAILS,
    actionData,
  };
}

export function toggleLoginPopup(actionData: IToggleLoginPopup['actionData']): IToggleLoginPopup {
  return {
    type: TOGGLE_LOGIN_POPUP,
    actionData,
  };
}

// ! move to api
export function prepareCommonUserWidgetRequest() {
  return `https://userservice.goibibo.com/ext/web/desktop/user/details`;
}

export const fetchUserDetailsThunk = (): ThunkAction<void, UserAppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<UserAppState, {}, AnyAction>, getState: () => UserAppState) => {
    dispatch(toggleLoadingUserDetailsAction(true));
    const url = prepareCommonUserWidgetRequest();
    const auth = getCookie('OAUTH-GOIBIBO')
    let requestData = JSON.stringify({ "query": [[{ "name": "extendedUser", "keys": ["profileId", "uuid", "primaryEmailId", "userType", "profileType", "loginInfoList", "personalDetails"] }], [{ "name": "extendedUser" }, { "name": "personalDetails", "keys": ["gender", "dateOfBirth"] }], [{ "name": "extendedUser" }, { "name": "userImages", "keys": ["fileUrl", "imageClass"], "filters": [{ "name": "imageClass", "type": "string", "value": "displaypic" }] }], [{ "name": "extendedUser" }, { "name": "profileCompletionDetails", "keys": ["ctaDetails", "completionScore", "title", "subText", "component"] }], [{ "name": "loginInfoList", "keys": ["loginId", "loginType", "primary", "status", "countryCode", "verified"] }], [{ "name": "miscFields", "keys": ["altEmailId"] }], [{ "name": "extendedUser" }, { "name": "addressDetails", "keys": ["addressId", "city", "name", "category", "houseNo", "street", "state", "country", "postalCode", "landMark", "status", "lastUpdated", "address1"] }]] })
    let sessionId = getSessionID()
    const headers = {
      ["Authorization"]: "jkO7Ivpwsh4KaQ9",
      ["Content-Type"]: "application/json",
      ["User-Identifier"]:
        JSON.stringify({ "type": "auth", "deviceId": "deviceId", "os": "desktop", "osVersion": "osVersion", "appVersion": "appVersion", "imie": "imie", "ipAddress": "ipAddress", "timeZone": "+5.30 GMT", "value": `${auth}` })
    };
    megatron({
      name: 'common userwidget api',
      type: 'POST',
      url,
      headers,
      requestData,
      credentials: 'include'
    })
      .then(async (response) => {
        if (response && response?.code !== 5405 && response?.result && response?.result?.extendedUser) {
          const { uuid = '', profileId = '', profileType = '', personalDetails = {}, primaryEmailId = '' } = response?.result?.extendedUser
          const { gender = '', name = {} } = personalDetails
          const { firstName = '', lastName = '' } = name
          const userAccountData = dispatch(getUserAccountDetailsThunk(auth, uuid, sessionId, profileType))
          const loyaltyData = dispatch(getLoyaltyDetailsThunk(auth, uuid))
          dispatch(
            updateUserDetailsAction({
              userInfo: { uuid, userid: uuid, profileId, profile_type: profileType, gender, first_name: firstName, last_name: lastName, email: primaryEmailId },
              isLoggedIn: uuid ? true : false,
            }),
          );
        }
        throw new Error('User Details API failed');
      })
      .catch(err => {
        dispatch(toggleLoadingUserDetailsAction(false));
        setSessionStorage('loyaltyInfo', '')
      });
  };
};

//loyaltyStatus API to get the currentTier of the suer
export const getLoyaltyDetailsThunk = (auth = '', uuid = ''): ThunkAction<void, UserAppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<UserAppState, {}, AnyAction>, getState: () => UserAppState) => {
    const goCashURL = 'https://membership-service.goibibo.com/loyalty/userInfo'
    let loyaltyStatusAPIBody = JSON.stringify({ "lob": "BUS", "tier": true, "benefit": false, "programDetails": false, "cards": false, "programDetailsTierBenefit": false, "source": "PWA", "platform": "DESKTOP", "pageType": "HOME" })
    const goCashHeader = {
      ["Authorization"]: '7NP82fpV0TsA9JrK',
      ["Auth"]: auth,
      ["Content-Type"]: "application/json",
      ["Org"]: "GI",
      ["Profile-Type"]: "PERSONAL",
    }
    megatron({
      name: 'common userwidget api',
      type: 'POST',
      url: goCashURL,
      headers: goCashHeader,
      requestData: loyaltyStatusAPIBody,
      credentials: 'omit'
    })
      .then((goCashResp) => {
        if (goCashResp) {
          dispatch(
            updateUserLoyaltyStatusAction({
              loyaltyInfo: { currentTier: goCashResp?.currentTier || {}, uuid: goCashResp?.uuid || '', status: goCashResp?.status || '', program: goCashResp?.program || '', firstName: goCashResp?.firstName || '', lastName: goCashResp?.lastName || '' },
            })
          )

          setSessionStorage('loyaltyInfo', `Tier${goCashResp?.status !=='INACTIVE' ? goCashResp?.currentTier?.tierNumber+'_' : '0_'}${goCashResp?.status || ''}`)
        }
      })
  }
}


export const getUserAccountDetailsThunk = (auth = '', uuid = '', sessionId = '', profileType = ''): ThunkAction<void, UserAppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<UserAppState, {}, AnyAction>, getState: () => UserAppState) => {
    const goCashURL = 'https://bus.goibibo.com/apis/mywallet/getaccountdetails/'
    let goCashAPIBody = JSON.stringify({ "organization": "gi", "currency": "INR", "region": "IN", "uuid": uuid, "profileType": profileType || "PERSONAL" })
    const dateString = dateformat(new Date(), 'yyyymmdd');
    const giTrackingToken = JSON.stringify([auth, uuid, dateString]);
    const goCashHeader = {
      ["Content-Type"]: "application/json",
      ["gi-tracking-token"]: encrypt(sessionId, giTrackingToken),
      ["session-id"]: sessionId,
    }
    megatron({
      name: 'common userwidget api',
      type: 'POST',
      url: goCashURL,
      headers: goCashHeader,
      requestData: goCashAPIBody,
      credentials: 'include'
    })
      .then((goCashResp) => {
        if (goCashResp) {
          dispatch(
            updateUserGoCashAction({
              gocashInfo: { credits_id: '', np_amt: goCashResp?.realBalance || '', p_amt: '', is_locked: goCashResp?.IsBlocked || '', b_amt: goCashResp?.bonusBalance || '', t_amt: goCashResp?.totalBalance || '' },
            })
          )
          return goCashResp;
        }
      })
  }
}


const initialState: IUserStoreState = {
  isLoading: null,
  userInfo: null,
  gocashInfo: null,
  isLoggedIn: false,
  showLoginPopup: false,
  loyaltyInfo:null,
};

export function userDetailsReducer(state = initialState, action: IUserActionTypes) {
  switch (action.type) {
    case UPDATE_USER_DETAILS:
      return {
        ...state,
        ...action.actionData,
        isLoading:false
      };

    case UPDATE_USER_GO_CASH_INFO:
      return {
        ...state,
        ...action.actionData,
      };
    case UPDATE_USER_LOYALTY_STATUS:
      return {
        ...state,
        ...action.actionData,
      };

    case TOGGLE_LOADING_USER_DETAILS:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case TOGGLE_LOGIN_POPUP:
      return {
        ...state,
        showLoginPopup: action.actionData,
      };

    default:
      return state;
  }
}

export const userReducer = {
  user: userDetailsReducer,
};

export const userSelector = createSelector(
  (state: UserAppState) => state.user,
  item => item,
);

const rootReducer = combineReducers(userReducer);
export type UserAppState = ReturnType<typeof rootReducer>;     